import { render, staticRenderFns } from "./CardTeacher.vue?vue&type=template&id=0613e03c&scoped=true"
import script from "./CardTeacher.vue?vue&type=script&lang=js"
export * from "./CardTeacher.vue?vue&type=script&lang=js"
import style0 from "./CardTeacher.vue?vue&type=style&index=0&id=0613e03c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0613e03c",
  null
  
)

export default component.exports